import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { BreadcrumbShowCountlabel, commonPageField, commonPageFieldSuccess } from "../../../store/actions";
import { mode, pageId } from "../../../routes";
import React, { useEffect, useState } from "react";
import { C_Button, SaveButton } from "../../../components/Common/CommonButton";
import GlobalCustomTable from "../../../GlobalCustomTable";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { C_Select } from "../../../CustomValidateForm";

import { MetaTags } from "react-meta-tags";
import DynamicColumnHook from "../../../components/Common/TableCommonFunc";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import * as _cfunc from "../../../components/Common/CommonFunction";

import { ServiceSettings_Fetch_Action, ServiceSettings_Save_Action } from "../../../store/Administrator/SeviceSettingRedux/action";
import SaveButtonDraggable from "../../../components/Common/saveButtonDraggable";
import { allLabelWithZero } from "../../../components/Common/CommonErrorMsg/HarderCodeData";



const ServiceSettings = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();

    // ---------------------- STATES ----------------------
    const [goBtnloading, setGoBtnloading] = useState(false);
    const [userPageAccessState, setUserAccState] = useState('');
    const [tableData, setTableData] = useState([]);
    const [partySelect, setPartySelect] = useState({ value: 0, label: "Select party" });
    const [pageMode] = useState(mode.defaultsave);

    // ---------------------- SELECTORS ----------------------
    const {
        ServiceSettingData,
        fetchLoading,
        saveLoading,
        partyDropdownLoading,
        saveResponse,
        Party,
        userAccess,
        pageField
    } = useSelector((state) => ({
        ServiceSettingData: state.ServiceSettingsReducer.ServiceSettingData,
        fetchLoading: state.ServiceSettingsReducer.fetchLoading,
        saveLoading: state.ServiceSettingsReducer.saveLoading,
        partyDropdownLoading: state.CommonPartyDropdownReducer.partyDropdownLoading,
        Party: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
        saveResponse: state.ServiceSettingsReducer.saveResponse,
    }));

    const location = { ...history.location };
    const hasShowModal = props.hasOwnProperty(mode.editValue);

    // ---------------------- UPDATE TABLE DATA ----------------------
    useEffect(() => {
        try {
            if (!ServiceSettingData) {
                setTableData([]);
                return;
            }

            if (Array.isArray(ServiceSettingData.Data)) {
                setTableData(ServiceSettingData.Data);
                return;
            }

            if (Array.isArray(ServiceSettingData)) {
                setTableData(ServiceSettingData);
                return;
            }

            setTableData([]);
        } catch (err) {
            console.error("Error mapping ServiceSettingData:", err);
            setTableData([]);
        }
    }, [ServiceSettingData]);

    // ---------------------- PAGE FIELD ----------------------
    useEffect(() => {
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageId.SERVICE_SETTINGS));

        return () => {
            dispatch(commonPageFieldSuccess(null));
        };
    }, []);

    // ---------------------- PARTY CHANGE ----------------------
    function PartyDrodownOnChange(e) {
        setPartySelect(e);
        setTableData([]);
    }

    // ---------------------- SAVE RESPONSE ----------------------
    useEffect(() => {
        if (!saveResponse || saveResponse.Status === undefined) return;

        if (saveResponse.Status === true && saveResponse.StatusCode === 200) {

            customAlert({
                Type: 1,
                Message: saveResponse.Message
            });

            if (partySelect?.value) {
                dispatch(ServiceSettings_Fetch_Action({ PartyID: partySelect.value }));
            }
        } else {
            customAlert({
                Type: 3,
                Message: saveResponse.Message
            });
        }

    }, [saveResponse]);

    // ---------------------- USER ACCESS ----------------------
    useEffect(() => {
        let locationPath = location.pathname;

        if (hasShowModal) {
            locationPath = props.masterPath;
        }

        const userAcc = userAccess.find(inx =>
            `/${inx.ActualPagePath}` === locationPath
        );

        if (userAcc) {
            setUserAccState(userAcc);
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        }
    }, [userAccess]);

    // ---------------------- PARTY OPTIONS ----------------------
    const Party_Option = [
        allLabelWithZero,
        ...(Party || []).map(i => ({
            value: i.id,
            label: i.Name,
            PartyType: i.PartyType
        }))
    ];

    // ---------------------- GO BUTTON ----------------------
    const goButtonHandler = async () => {
        ;

        if (!partySelect || partySelect.value === undefined || partySelect.value === null) {
            customAlert({ Type: 3, Messages: "selectParty" });
            return;
        }

        dispatch(
            ServiceSettings_Fetch_Action({ PartyID: partySelect.value })
        );
    };

    // ---------------------- SAVE HANDLER ----------------------
    const SaveHandler = async (event) => {
        event.preventDefault();
        ;

        try {
            const payload = {
                Party: partySelect.value,
                SettingList: tableData
                    .filter(row => row._isEdited)
                    .map(row => ({
                        ServiceSettingsID: row.ServiceSettingsID,
                        CreatedOn: "2024-12-24 17:19:22.000000",
                        UpdatedOn: "2025-10-14 16:02:04.448549",
                        Flag: row.Flag,
                        Value: row.Value,
                        Access: row.Access
                    }))
            };

            console.log("FINAL PAYLOAD:", payload);

            dispatch(
                ServiceSettings_Save_Action({
                    jsonBody: JSON.stringify(payload)
                })
            );

        } catch (e) {
            console.error(e);
        }
    };

    // ---------------------- TABLE VALUE CHANGE ----------------------
    const handleToggleChange = (id, key) => {
        setTableData(prev =>
            prev.map(row =>
                row.id === id
                    ? { ...row, [key]: !row[key], _isEdited: true }
                    : row
            )
        );
    };


    const handleValueChange = (id, value) => {
        setTableData(prev =>
            prev.map(row =>
                row.id === id
                    ? { ...row, Value: value, _isEdited: true }
                    : row
            )
        );
    };


    // ---------------------- TABLE COLUMNS ----------------------
    const [tableColumns] = DynamicColumnHook({ pageField });

    const updatedColumns = tableColumns.map(col => {

        // VALUE INPUT
        if (col.dataField === "Value") {
            return {
                ...col,
                headerStyle: { width: "300px" },
                formatter: (cell, row, rowIndex) => (
                    <input
                    type="text"
                    defaultValue={row.Value || ""}
                    className="form-control"
                    style={{ width: "100%" }}
                    onBlur={(e) => handleValueChange(row.id, e.target.value)}
                />
                )
            };
        }

        // FLAG SWITCH
        if (col.dataField === "Flag") {
            return {
                ...col,
                formatter: (cell, row, rowIndex) => (
                    <div className="form-check form-switch form-switch-md" >
                        <input
                            className="form-check-input "
                            type="checkbox"
                            checked={!!row.Flag}
                            onChange={() => handleToggleChange(row.id, "Flag")}

                        />
                    </div>
                )
            };
        }

        // ACCESS SWITCH
        if (col.dataField === "Access") {
            return {
                ...col,
                formatter: (cell, row, rowIndex) => (
                    <div className="form-check form-switch form-switch-md">
                        <input
                            className="form-check-input "
                            type="checkbox"
                            checked={!!row.Access}
                            onChange={() => handleToggleChange(row.id, "Access")}

                        />
                    </div>
                )
            };
        }

        return col;
    });







    return (
        <React.Fragment>
            <MetaTags>
                {_cfunc.metaTagLabel(userPageAccessState)}
            </MetaTags>

            <div className="px-2 c_card_filter text-black">
                <div className="row mb-1">
                    <Row className="d-flex align-items-center">

                        {/* Party Dropdown */}
                        <Col sm={5} className="mb-3 ms-2 mt-1">
                            <FormGroup className="row mt-2 mb-0 align-items-center">
                                <Label
                                    className="col-sm-4 p-2"
                                    style={{ width: "65px", marginRight: "10px" }}
                                >
                                    Party
                                </Label>

                                <Col sm="8">
                                    <C_Select
                                        name="Party"
                                        value={partySelect}
                                        isSearchable
                                        isLoading={partyDropdownLoading}
                                        className="react-dropdown"
                                        classNamePrefix="dropdown"
                                        placeholder="Select Party"
                                        styles={{
                                            menu: (provided) => ({ ...provided, zIndex: 2 })

                                        }}
                                        options={Party_Option}
                                        onChange={PartyDrodownOnChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>

                        <Col sm={5}></Col>

                        {/* GO Button */}
                        <Col sm={1} className="d-flex justify-content-end" style={{ marginLeft: 50 }} >
                            <C_Button
                                type="button"
                                spinnerColor="white"
                                loading={fetchLoading}
                                className="btn btn-success "
                                onClick={goButtonHandler}
                            >
                                GO
                            </C_Button>
                        </Col>

                    </Row>
                </div>
            </div>

            <div>
                <div className="mb-1">
                    <GlobalCustomTable
                        keyField="id"
                        data={tableData}
                        columns={updatedColumns}
                        id="table_Arrow"
                        paginationEnabled={50}
                        noDataIndication={
                            <div className="text-danger text-center">
                                Items Not available
                            </div>
                        }
                        onDataSizeChange={({ dataCount, filteredData }) => {
                            dispatch(
                                BreadcrumbShowCountlabel(`Count:${dataCount} `)
                            );
                            dispatch(
                                BreadcrumbShowCountlabel(
                                    `Count:${dataCount} currency_symbol ${_cfunc.TotalAmount_Func(filteredData)}`
                                )
                            );
                        }}
                    />
                </div>

                <SaveButtonDraggable>
                    <SaveButton
                        loading={saveLoading}
                        pageMode={pageMode}
                        userAcc={userPageAccessState}
                        onClick={SaveHandler}
                    />
                </SaveButtonDraggable>
            </div>
        </React.Fragment>
    );

};

export default ServiceSettings;
